const SOURCE_HEADING_REGEX = /^(?:#{1,6}\s*)?(?:sources?|source references?|references?|citations?|sumber|referensi|daftar pustaka|fuentes?|fontes?|fonti|quellen|bron(?:nen)?|kilder|kallor|istocniki|источники|kaynak(?:lar)?|مصادر|出典|出處|出处|來源|来源|출처)\s*[:：]\s*$/iu;
const SOURCE_SECTION_MARKERS = new Set([
  '--format:sources',
  '--format:source',
  '--format:references',
  '--format:sumber',
]);

/**
 * Convert a detected trailing sources section into blockquote markdown
 * so the renderer can apply muted styling consistently.
 */
export const formatSourceSectionAsBlockquote = (content: string): string => {
  if (!content) return content;

  const lines = content.split(/\r?\n/);
  const markerIndex = lines.findIndex((line) => SOURCE_SECTION_MARKERS.has(line.trim().toLowerCase()));
  if (markerIndex !== -1) {
    const transformed = lines
      .map((line, index) => {
        if (index < markerIndex) return line;
        if (index === markerIndex) return null;
        if (line.trim().length === 0) return '>';
        if (line.trimStart().startsWith('>')) return line;
        return `> ${line}`;
      })
      .filter((line): line is string => line !== null);

    return transformed.join('\n');
  }

  const sourceHeadingIndex = lines.findIndex((line) => SOURCE_HEADING_REGEX.test(line.trim()));
  if (sourceHeadingIndex === -1) return content;

  const transformed = lines.map((line, index) => {
    if (index < sourceHeadingIndex) return line;
    if (line.trim().length === 0) return '>';
    if (line.trimStart().startsWith('>')) return line;
    return `> ${line}`;
  });

  return transformed.join('\n');
};
